module.exports = __webpack_public_path__ + "img/table3.cc2a4992.jpg";